{
  "{0} Invitation(s) successfully sent": "{0} Invitation(s) successfully sent",
  "{0} properties added to the brand": "{0} properties added to the brand",
  "{0} properties added to the cluster": "{0} properties added to the cluster",
  "{0} properties added to user": "{0} properties added to user",
  "{assigned} of {total} User assigned | {assigned} of {total} Users assigned": "{assigned} de {total} Utilizadores atribuídos | {assigned} de {total} Utilizadores atribuídos",
  "{boldPart} To remove the page from a single property only, edit the page and remove that property's mapping rule instead.": "{boldPart} Para remover a página de uma única propriedade, edite a página e remova a regra de mapeamento dessa propriedade.",
  "{count} properties": "{count} propriedades",
  "{count} weren't updated": "{count} não foram atualizados",
  "{num} user(s) assigned to the property": "Usuário(s) {num} atribuídos à propriedade",
  "{num} user(s) assigned to the site": "Usuário(s) {num} atribuídos ao site",
  "1 wasn't updated": "1 não foi atualizado",
  "A cluster or brand with this name already exists. Please, choose another one.": "Já existe um cluster ou marca com este nome. Por favor, escolha outro.",
  "A page with this name already exists. Please, choose another one.": "Uma página com este nome já existe. Por favor, escolha outro.",
  "A report will be sent by email every first week of the month summarizing the previous months data.": "A report will be sent by email every first week of the month summarizing the previous month's data.",
  "A report will be sent by email every week summarizing the previous weeks data.": "A report will be sent by email every week summarizing the previous week's data.",
  "A report will be sent by email summarizing the previous days data.": "A report will be sent by email summarizing the previous day's data.",
  "Access to data analytics on the Personalization Dashboard and BenchDirect for specific properties of the account": "Acesso à análise de dados no Painel de Personalização e BenchDirect para propriedades específicas da conta",
  "Access to operate in all products for specific properties of the account, without permission to edit settings": "Acesso para operar em todos os produtos para propriedades específicas da conta, sem permissão para editar definições",
  "Account": "Conta",
  "Account information": "Account information",
  "Account settings": "Account settings",
  "Account users": "Account users",
  "Account was successfully updated.": "A conta foi atualizada com sucesso.",
  "Action required: Please {link} to continue.": "Ação necessária: Por favor, {link} para continuar.",
  "Activated": "Ativado",
  "Add": "Adicionar",
  "Add another set of rules": "Adicionar outro conjunto de regras",
  "Add JavaScript condition": "Adicionar condição JavaScript",
  "Add new notification": "Adicionar nova notificação",
  "Add page": "Adicionar página",
  "Add properties": "Add properties",
  "Add properties to this brand": "Add properties to this brand",
  "Add properties to this cluster": "Add properties to this cluster",
  "Add the email(s) of the user(s) you want to invite:": "Add the email(s) of the user(s) you want to invite:",
  "Add user(s) email...": "Add user(s) email...",
  "added": "added",
  "Admin": "Admin",
  "Adults Only": "Apenas Adultos",
  "Airport Hotel": "Hotel do aeroporto",
  "All": "All",
  "All data changes will be updated after 24hrs, so don’t worry if you don’t see your changes applied immediatly.": "All data changes will be updated after 24hrs, so don’t worry if you don’t see your changes applied immediatly.",
  "All properties": "All properties",
  "All properties from all my accounts.": "All properties from all my accounts.",
  "All properties from this account selected.": "All properties from this account selected.",
  "All properties from this account.": "All properties from this account.",
  "All properties from your accounts selected.": "All properties from your accounts selected.",
  "All rules apply": "Aplicam-se todas as regras",
  "All the properties were updated successfully.": "Todas as propriedades foram atualizadas com sucesso.",
  "All the sites were updated successfully.": "Todos os sites foram atualizados com sucesso.",
  "All your properties have already been assigned to a brand group. Transfer properties from other brands if you want to populate a new brand group": "Todas as suas propriedades já foram atribuídas a um grupo de marcas. Transfira propriedades de outras marcas se quiser preencher um novo grupo.",
  "All your team members have access to this property.": "All your team members have access to this property.",
  "All your team members have access to this site.": "Todos os membros da sua equipe têm acesso a este site.",
  "An error occurred while sending the email. Please try again later.": "Ocorreu um erro ao enviar o e-mail. Por favor, tente novamente mais tarde.",
  "An error occurred. Please try again": "An error occurs. Please try again",
  "analyst": "analista",
  "Analyst": "analista",
  "Any rule applies": "Qualquer regra se aplica",
  "Aparthotel": "Aparthotel",
  "Are you sure you want to delete this brand?": "Are you sure you want to delete this brand?",
  "Are you sure you want to delete this cluster?": "Are you sure you want to delete this cluster?",
  "Are you sure you want to proceed?": "Tens a certeza que queres continuar?",
  "Are you sure you want to remove the access?": "Are you sure you want to remove the access?",
  "Are you sure you want to remove this property from this brand?": "Are you sure you want to remove this property from this brand?",
  "Are you sure you want to remove this property from this cluster?": "Are you sure you want to remove this property from this cluster?",
  "Are you sure you want to remove this user from this account?": "Are you sure you want to remove this user from this account?",
  "Ask Ernest": "Pergunte a Ernest",
  "Available languages": "Available languages",
  "Back": "Voltar",
  "Back to Pages": "Voltar às páginas",
  "Beach": "Praia",
  "BenchDirect": "BenchDirect",
  "Benchdirect": "BenchDirect",
  "Benchmark the key metrics of your direct booking channel": "Benchmark das métricas-chave do seu canal direto",
  "Benchmark the key metrics of your direct channel": "Benchmark das métricas-chave do seu canal direto",
  "Book multiplier": "Book multiplier",
  "Book Multiplier": "Multiplicador de reservas",
  "Booking Engine Pages": "Páginas do motor de reservas",
  "Booking Engine pages include {pageExamples} and others. Your Booking Engine pages can't be edited. If you encounter any issues on these pages, please contact our Support team via chat.": "As páginas do Booking Engine incluem {páginaExemplos} e outras. As páginas do Booking Engine não podem ser editadas. Se você encontrar algum problema nessas páginas, entre em contato com nossa equipe de Suporte por chat.",
  "Boutique": "Boutique",
  "Brand": "Brand",
  "Brand information": "Brand information",
  "Brand name": "Brand name",
  "Brands": "Brands",
  "Brands allow you to group your properties however you may need.": "As marcas permitem-lhe agrupar as suas propriedades da forma que desejar.",
  "Brands without any properties will be deleted after 30 days of inactivity": "Brands without any properties will be deleted after 30 days of inactivity",
  "Business": "Negócios",
  "Can’t access 1Password?": "Não consegue acessar 1Password?",
  "Cancel": "Cancel",
  "Casino": "Casino",
  "Category (Stars)": "Category (Stars)",
  "Change password": "Change password",
  "Change the user role to adjust permissions": "You can change the role of the user to modify his/her permissions",
  "Change your password": "Change your password",
  "Check the items that you want to copy.": "Verifique os artigos que deseja copiar.",
  "Choose a beautiful picture of your hotel. This landing photo is used in multiple tools, whenever THN creates a page/email for the hotel. For example, in the Saved Searches email.": "Choose a beautiful picture of your hotel. This landing photo is used in multiple tools, whenever THN creates a page/email for the hotel. For example, in the Saved Searches email.",
  "Choose a beautiful picture of your site. This landing photo is used in multiple tools, whenever THN creates a page/email for the site. For example, in the Saved Searches email.": "Escolha uma imagem bonita do seu site. Essa foto de destino é usada em várias ferramentas, sempre que a THN cria uma página/e-mail para o site. Por exemplo, no e-mail de pesquisas salvas.",
  "Choose a product to start": "Escolha um produto para começar",
  "Choose file": "Choose file",
  "Choose for which properties you'll upload URLs": "Escolha para que propriedades irá carregar URLs",
  "Choose languages": "Escolher línguas",
  "City": "Cidade",
  "Cluster Information": "Cluster Information",
  "Cluster name": "Cluster name",
  "Clusters": "Clusters",
  "Clusters allow you to group your hotels with the same cluster.": "Clusters allow you to group your hotels with the same cluster.",
  "Clusters allow you to group your properties however you may need.": "Clusters allow you to group your properties however you may need.",
  "Color": "Color",
  "Conference": "Conferência",
  "Configure the communications that you want to receive from us through the link below. Apart from this configuration, you will receive relevant product news that may affect you.": "Configure the communications that you want to receive from us through the link below. Apart from this configuration, you will receive relevant product news that may affect you.",
  "Confirm": "Confirme",
  "Confirm new password": "Confirm new password",
  "Confirm password": "Confirmar palavra-passe",
  "Content": "Conteúdo",
  "Conversion": "Conversão",
  "Convince your visitors to book directly on your website": "Convença os seus visitantes a reservar directamente no seu website",
  "Copied": "Copied",
  "Copied settings will be assigned to the selected properties:": "As configurações copiadas serão atribuídas às propriedades selecionadas:",
  "Copied settings will be assigned to the selected sites:": "As configurações copiadas serão atribuídas aos sites selecionados:",
  "Copy": "Copy",
  "Copy and paste this code just before the closing body tag {bodyTag} in all the funnel pages and any extra page where you want to use THN. If you have any doubt don't hesitate on contacting us.": "Copie e colar este código logo antes da tag corporal de fechamento {bodyTag} em todas as páginas de embudo e qualquer página extra onde você deseja usar THN. Se você tiver qualquer dúvida, não hesite em contactar-nos.",
  "Copy settings to other corporate sites": "Copiar definições para outros sítios da empresa",
  "Copy settings to other properties": "Copy settings to other properties",
  "Copy settings to other properties:": "Copiar definições para outras propriedades:",
  "Copy settings to other sites:": "Copiar configurações para outros sites:",
  "Corporate landing picture": "Imagem de apresentação da empresa",
  "Corporate logo": "Logótipo da empresa",
  "Corporate picture": "Imagem corporativa",
  "Corporate Sites": "Sites corporativos",
  "corporate sites": "Sites corporativos",
  "Create a Login item for your THN account. Click the three dots to the top right and choose “Scan QR code”. Find a {link}.": "Crie um item de início de sessão para a sua conta THN. Clique nos três pontos no canto superior direito e selecione «Ler código QR». Encontre um {link}.",
  "Create brand": "Create brand",
  "Create cluster": "Create cluster",
  "Create Login item and scan QR code": "Criar um item de início de sessão e digitalizar o código QR",
  "Create new brand": "Create new brand",
  "Create new cluster": "Create new cluster",
  "Create new corporate site": "Criar um novo sítio da empresa",
  "Create notification": "Create notification",
  "Create site": "Criar site",
  "Create your account": "Crie a sua conta",
  "Create your first Corporate Site": "Criar o seu primeiro sítio da empresa",
  "Currency and date format preferences when there’s not a property selected. This applies to Overview and brand page reports.": "Preferências de formato de moeda e data quando não há uma propriedade selecionada. Isto aplica-se aos relatórios de visão geral e de página de marca.",
  "Currency format": "Currency format",
  "Currency in which you will see all the data for this corporate site.": "Moeda em que você verá todos os dados para este site corporativo.",
  "Currency in which you will see all the data for this property.": "Currency in which you will see all the data for this property.",
  "Current password": "Current password",
  "Daily": "Daily",
  "Daily:": "Daily: ",
  "Dashboard": "Painel de instrumentos",
  "Data about a particular {propertyType} or a particular user is never shared. The data is used to create competitive sets (groups of hotels that you can measure your performance against) and compare metrics between your hotels and their compsets. All data shown in BenchDirect is aggregate data.": "Os dados sobre um determinado {propertyType} ou um usuário específico nunca são compartilhados. Os dados são usados para criar conjuntos competitivos (grupos de hotéis com os quais você pode medir seu desempenho) e comparar métricas entre seus hotéis e seus compostos. Todos os dados mostrados no BenchDirect são dados agregados.",
  "Data updating": "Data updating",
  "Dates format": "Dates format",
  "Deactivated": "Desativado",
  "Default currency": "Default currency",
  "Delete": "Eliminar",
  "Delete brand": "Delete brand",
  "Delete cluster": "Delete cluster",
  "Delete notification": "Eliminar notificação",
  "Delete page": "Eliminar página",
  "Delete photo": "Delete photo",
  "Deleting the page will remove any active messages from it. Those messages will be active on any other pages they're assigned to.": "A eliminação da página removerá todas as mensagens activas da mesma. Essas mensagens continuarão activas em quaisquer outras páginas a que estejam atribuídas.",
  "Demand": "Demanda",
  "demand_product_description": "Conduzir tráfego qualificado para o seu sítio Web através de campanhas pagas",
  "Didn't receive the email? {btn}": "Didn't receive the email? {btn}",
  "Disparities": "Disparities",
  "Do you already have an account? {btn}": "Já tem uma conta? {btn}",
  "Do you want to compare your performance to the market and competition? Access our hotel benchmarking analytics platform.": "Quer comparar o seu desempenho com o mercado e a concorrência? Aceda à nossa plataforma analítica de benchmarking.",
  "Do you want to delete this notification?": "Queres eliminar esta notificação?",
  "Do you want to delete this page?": "Pretende apagar esta página?",
  "Do you want to get more direct bookings? Use personalization tools to tailor messages and offers according to each individual's behaviour.": "Quer obter mais reservas diretas? Utilize ferramentas de personalização para personalizar mensagens e ofertas de acordo com o comportamento de cada indivíduo.",
  "Don't remind me again": "Não me lembres mais",
  "Don’t have an account? {btn}": "Não tem uma conta? {btn}",
  "Download property list.": "Baixar lista de propriedades.",
  "Download template": "Descarregar modelo",
  "Drive qualified traffic to your hotel's website and effortlessly boost conversions thanks to our cutting-edge demand platform and fully-managed marketing services. Request a demo.": "Dirija tráfego qualificado para o sítio Web do seu hotel e aumente as conversões sem esforço graças à nossa plataforma de procura de ponta e aos serviços de marketing totalmente geridos. Solicite uma demonstração.",
  "Drop files here": "Drop files here",
  "Drop icon": "Drop icon",
  "Each property can only use one mapping rule type per page, and they're already set to a different rule. Remove their existing rule first and import again.": "Cada propriedade pode usar apenas um tipo de regra de mapeamento por página, e elas já estão configuradas para uma regra diferente. Remova a regra existente primeiro e importe novamente.",
  "Edit": "Editar",
  "Edit account role": "Edit account role",
  "Edit brand": "Edit brand",
  "Edit cluster": "Edit cluster",
  "Edit notification": "Editar notificação",
  "Edit Property": "Edit property",
  "Edit role": "Edit role",
  "Edit site": "Editar site",
  "Edit user": "Edit user",
  "Editing properties": "Editar propriedades",
  "Editing sites": "Edição de sites",
  "Editing successful!": "A edição foi bem-sucedida!",
  "Editing unsuccessful!": "Editar sem sucesso!",
  "Email": "Email",
  "Email communications from THN": "Email communications from THN",
  "Email notifications": "Notificações de e-mail",
  "Empty": "Empty",
  "English": "Inglês",
  "english": "Inglês",
  "English selected by default": "English selected by default",
  "Enter a 6-digit code": "Introduzir um código de 6 dígitos",
  "Enter a description for the site": "Introduza uma descrição para o site",
  "Enter a password": "Introduza uma palavra-passe",
  "Enter a password with at least 8 characters": "Introduza uma palavra-passe com, pelo menos, 8 caracteres",
  "Enter the code from 1Password to verify your identity.": "Introduza o código do 1Password para verificar a sua identidade.",
  "Enter the email address related to this account and we'll send you the instructions to reset your password.": "Enter the email address related to this account and we'll send you the instructions to reset your password.",
  "Enter your account name": "Enter your account name",
  "Enter your code": "Introduza o seu código",
  "Enter your current password": "Enter your current password",
  "Enter your email": "Introduza o seu e-mail",
  "Enter your last name": "Introduza o seu apelido",
  "Enter your name": "Introduza o seu nome",
  "Enter your password": "Introduza a sua palavra-passe",
  "Experience the power of next-gen AI across our products": "Experimente o poder da IA de próxima geração nos nossos produtos",
  "Family": "Família",
  "First name": "Nome próprio",
  "follow these instructions": "siga estas instruções",
  "Forgot your password?": "Esqueceu-se da sua palavra-passe?",
  "Forgot your password? {btn}": "Esqueceu-se da sua palavra-passe? {btn}",
  "Frequency": "Frequency",
  "Full access to all products as well as edit and manage all properties, invite users and assign roles": "Acesso total a todos os produtos, bem como editar e gerir todas as propriedades, convidar utilizadores e atribuir funções",
  "General preferences": "General preferences",
  "Get a digest in your inbox and keep track of your disparities.": "Get a digest in your inbox and keep track of your disparities.",
  "Get more info": "Obter mais informações",
  "Get the summary of the percentage change in each of the metrics: conversion, bookings, rates (BAR) and disparities.": "Get the summary of the percentage change in each of the metrics: conversion, bookings, rates (BAR) and disparities.",
  "Get your summary report directly in your inbox!": "Obtenha seu relatório de resumo diretamente na sua caixa de entrada!",
  "Go back": "Voltar atrás",
  "Go to Help Center": "Go to Help Center",
  "Golf": "Golfe",
  "Google Analytics": "Google Analytics",
  "Group your properties by brand!": "Agrupe os seus imóveis por marca!",
  "Having trouble with your data?": "Having trouble with your data?",
  "help center": "centro de ajuda",
  "Here you have a summary of some of the most common errors. Check it out!": "Here you have a summary of some of the most common errors. Check it out!",
  "Hostel": "Albergue",
  "Hotel address": "Hotel address",
  "Hotel information": "Hotel information",
  "Hotel landing picture": "Hotel landing picture",
  "Hotel logo": "Hotel logo",
  "Hotel profile": "Hotel profile",
  "Hotel Profile": "Perfil do Hotel",
  "Hotel type": "Hotel type",
  "How is the data used and processed?": "How is the data used and processed?",
  "I agree to the terms and conditions of the {privacyPolicyLink}": "Concordo com os termos e condições da {privacyPolicyLink}",
  "I have already scanned it": "Eu já escaneei isso",
  "If enabled, every time widgets are shown an event will be created in Google Analytics.": "If enabled, every time widgets are shown an event will be created in Google Analytics.",
  "If the email matches the one we have on your account, you will receive an email with the password recovery instructions shortly. Please make sure to refresh your inbox.": "If the email matches the one we have on your account, you will receive an email with the password recovery instructions shortly. Please make sure to refresh your inbox.",
  "If you are using Google Tag Manager (GTM), please {link} once you activate this setting.": "Se você estiver usando o Google Tag Manager (GTM), por favor, {link} depois de ativar esta configuração.",
  "If you remove this property, the brand will be empty and automatically deleted.": "Se você remover essa propriedade, a marca ficará vazia e será automaticamente excluída.",
  "If you remove this property, the cluster will be empty and automatically deleted.": "Se você remover esta propriedade, o cluster ficará vazio e será automaticamente excluído.",
  "Import": "Importação",
  "Import URLs in bulk": "Importar URLs em massa",
  "Incorrect email or password. Please try again or {link}.": "Email ou senha incorretos. Por favor, tente novamente ou {link}.",
  "Info": "Informações",
  "Install and login to the 1Password extension.": "Instale a extensão do 1Password e inicie sessão.",
  "Install the 1Password browser extension": "Instale a extensão do 1Password para o navegador",
  "Install the THN Script on your website": "Instalar o Script THN no seu site",
  "Integration": "Integração",
  "Integration setup": "Integration setup",
  "Invalid CSV format.": "Formato CSV inválido.",
  "Invalid or expired code, try again.": "Código inválido ou vencido, tente novamente.",
  "Invitation couldn't be sent": "Não foi possível enviar o convite",
  "Invitation successfully sent.": "O convite foi enviado com sucesso.",
  "Invite link expired": "O link do convite expirou",
  "Invite new user(s)": "Invite new user(s)",
  "Invite users": "Invite users",
  "It looks like this invite link has expired. Please check with your account owner or your Client Success Specialist if you need help.": "Parece que este link de convite expirou. Contacte o proprietário da sua conta ou o seu Client Success Specialist se precisar de ajuda.",
  "It looks like this link has already been used or has expired.": "Parece que este link já foi utilizado ou expirou.",
  "JavaScript condition is": "A condição JavaScript é",
  "Language": "Language",
  "Language direction": "Direcção linguística",
  "Languages in which your website is available. When you create notes or other texts, you will see a box to enter the translations for each of these languages.": "Languages in which your website is available. When you create notes or other texts, you will see a box to enter the translations for each of these languages.",
  "Last name": "Apelido",
  "Left to right": "Left to right",
  "Leisure": "Lazer",
  "Loading ...": "Loading ...",
  "Log out": "Log out",
  "Login": "Entrar",
  "Logo": "Logo",
  "Looks like you are the only one in the account": "Looks like you are the only one in the account",
  "Luxury": "Luxo",
  "Manage languages": "Manage languages",
  "Manage Preferences": "Manage Preferences",
  "Manage the access to properties for this user.": "Manage the access to properties for this user.",
  "Mapped for": "Mapeado para",
  "Mapping Rules": "Regras de mapeamento",
  "Mapping Values": "Mapeamento de valores",
  "Meet Ernest": "Conheça Ernest",
  "Monthly": "Monthly",
  "Monthly:": "Monthly: ",
  "More information here": "Mais informações aqui",
  "Motel": "Motel",
  "Must accept terms and conditions": "Deve aceitar os termos e condições",
  "Must have at least 1 lowercase, 1 uppercase, 1 numeric character and length must be between 8 and 20.": "Must have at least 1 lowercase, 1 uppercase, 1 numeric character and length must be between 8 and 20.",
  "Name": "Name",
  "New password": "New password",
  "Next": "Next",
  "No account available with the name: {name}": "Nenhuma conta disponível com o nome: {name}",
  "No brand created yet": "Ainda não foi criada nenhuma marca",
  "No data found": "No data found",
  "No matches found for your search": "Não foram encontradas correspondências para a sua pesquisa",
  "Nº of rooms": "Nº of rooms",
  "No properties": "Sem propriedades",
  "No properties available.": "Não existem imóveis disponíveis.",
  "No properties found in this account": "Não foram encontradas propriedades nesta conta",
  "No valid rows found.": "Não foram encontradas linhas válidas.",
  "None": "None",
  "Not now": "Não agora",
  "Notification created.": "Notificação criada.",
  "Notification icon": "Notification icon",
  "Notification was deleted.": "A notificação foi eliminada.",
  "Notification was saved.": "A notificação foi guardada.",
  "Notifications": "Notifications",
  "Now selected:": "Agora selecionado:",
  "Now you can access to our products and boost your hotel direct bookings.": "Agora pode aceder aos nossos produtos e impulsionar as reservas diretas do seu hotel.",
  "of": "of",
  "Ok": "OK",
  "Once deleted, it can't be restored.": "Depois de eliminado, não pode ser recuperado.",
  "Only images are allowed": "Só são permitidas imagens",
  "Oops! You don't have access to any account": "Oops! You don't have access to any account",
  "Oops! You don't have access to any property or product. Please contact the person responsible for THN within your team.": "Oops! You don't have access to any property or product. Please contact the person responsible for THN within your team.",
  "Operator": "operador",
  "Ops, something went wrong. Please try again later.": "Ups, ocorreu um erro. Por favor, tente novamente mais tarde.",
  "optional": "Opcional",
  "or": "or",
  "Overview preferences": "Overview preferences",
  "Owner": "dono",
  "Ownership couldn't be transferred.": "A propriedade não pode ser transferida.",
  "Ownership successfully transferred.": "A propriedade foi transferida com sucesso.",
  "Page deleted successfully": "Página eliminada com sucesso",
  "Page ID": "ID da página",
  "Page name": "Nome da página",
  "Page saved successfully": "Página guardada com sucesso",
  "Pages": "Páginas",
  "Pages created rely on the THN Script being installed to collect data and display your messages on the corresponding pages of your site.": "As páginas criadas dependem da instalação do THN Script para recolher dados e apresentar as suas mensagens nas páginas correspondentes do seu site.",
  "Password": "Palavra-passe",
  "Password reset sent": "Password reset sent",
  "Passwords do not match": "As palavras-passe não coincidem",
  "Pending confirmation": "Confirmação pendente",
  "Personal information": "Personal information",
  "Personalization": "Personalização",
  "Personalize the user experience to boost conversion rates": "Personalize a experiência do utilizador para impulsionar as taxas de conversão",
  "Personalize your hotel website's full funnel": "Personalize todos os passos da página web do seu hotel",
  "Please, complete the following information:": "Por favor, preencha as seguintes informações:",
  "Please, contact {btn}": "Por favor, entre em contato com {btn}",
  "Please, contact the person responsible for THN within your team.": "Please, contact the person responsible for THN within your team.",
  "Please, introduce your current password and then set a new one": "Please, introduce your current password and then set a new one",
  "Please, retry to edit these properties.": "Por favor, tente novamente para editar essas propriedades.",
  "Please, retry to edit these sites.": "Por favor, tente novamente para editar esses sites.",
  "Please, select the account in which you want to log in:": "Please, select the account in which you want to log in:",
  "Please, select the brand to allocate this property:": "Por favor, selecione a marca para atribuir esta propriedade:",
  "Please, select the cluster to allocate this property:": "Por favor, selecione o Cluster para atribuir esta propriedade:",
  "Please, try again": "Por favor, tente novamente",
  "Preferences": "Preferences",
  "Priority": "Prioridade",
  "Privacy Policy": "Política de Privacidade",
  "Profile": "Profile",
  "Properties": "Properties",
  "properties": "properties",
  "Properties included": "Properties included",
  "Properties selected": "Properties selected",
  "Property": "Property",
  "Property access": "Property access",
  "Property name": "Property name",
  "Property's script": "Script del sítio da empresa",
  "QR code for two-factor authentication setup": "Código QR para a configuração da autenticação de dois fatores",
  "Ready to take your hotel's direct booking strategy to new heights?": "Pronto para levar a estratégia de reservas directas do seu hotel a novos patamares?",
  "Recipients": "Recipients",
  "RegExp contains": "RegExp Contém",
  "Remind to this user to accept the invitation you sent to join the account.": "Lembra este utilizador de aceitar o convite que lhe enviaste para se juntar à conta.",
  "Remove access": "Remove access",
  "Remove from brand": "Remove from brand",
  "Remove from cluster": "Remove from cluster",
  "Remove properties and delete brand": "Remover propriedades e excluir marca",
  "Remove properties and delete cluster": "Remover propriedades e excluir cluster",
  "Remove property": "Remove property",
  "Remove user": "Remove user",
  "Removed access to {0} properties": "Removed access to {0} properties",
  "Removing {0} of {1}": "Removing {0} of {1}",
  "Repeat password": "Repita a palavra-passe",
  "Reset password link expired": "O link para definir a sua palavra-passe expirou",
  "Reset your password": "Definir a sua palavra-passe",
  "Resort": "Estância",
  "Restricted property": "Propriedade restrita",
  "Return to login": "Return to login",
  "Right to left": "Right to left",
  "Role": "Role",
  "Rooms and Rates, Booking Confirmed, User Register Page": "Quartos e Tarifas, Reservas Confirmadas, Registo de Usuário",
  "Save changes": "Save changes",
  "Save new page": "Guardar nova página",
  "Save selection": "Salvar seleção",
  "Search": "Pesquisar",
  "Search ...": "Search ...",
  "Search account": "Search account",
  "Search brand...": "Procurar marca...",
  "Search cluster...": "Pesquisar Cluster...",
  "Search properties ...": "Search properties ...",
  "Search users...": "Procurar utilizadores...",
  "Search...": "Search...",
  "Seems like there aren’t any brands created yet": "Parece que ainda não há nenhuma marca criada.",
  "Seems like there aren’t any clusters created yet": "Parece que ainda não foram criados Clusters.",
  "Select a product": "Selecione um produto",
  "Select only languages that are available in your hotel website": "Select only languages that are available in your hotel website",
  "Select properties": "Propriedades selecionadas",
  "Select property": "Selecionar propriedade",
  "Select role for the user(s):": "Select role for the user(s):",
  "Select sites": "Sites selecionados",
  "Select the properties that you want to add to this brand:": "Selecione as propriedades que você deseja adicionar a esta marca:",
  "Select the properties you want the notifications from:": "Select the properties you want the notifications from:",
  "Select the properties you want to add to this brand:": "Select the properties that you want to add to this brand:",
  "Select the properties you want to add to this cluster:": "Seleccione as propriedades que pretende adicionar a este cluster:",
  "Select the properties you want to assign to this user(s):": "Select the properties you want to assign to this user(s):",
  "Select the type of notification:": "Select the type of notification:",
  "Select the user(s) you want to share this property with:": "Select the user(s) you want to share this property with:",
  "Select the user(s) you want to share this site with:": "Selecione o(s) usuário(s) com quem deseja partilhar este site:",
  "selected": "selected",
  "Send a new one": "Send a new one",
  "Send a reminder": "Enviar um lembrete",
  "Send invite(s)": "Send invite(s)",
  "Send periodic reports to anyone you wish": "Envie relatórios periódicos para quem quiser",
  "Send reminder": "Enviar lembrete",
  "Send reset instructions": "Enviar instruções de recuperação",
  "Set a new one here": "Defina um novo aqui",
  "Set new password": "Set new password",
  "Set up 1Password 2FA": "Configurar a autenticação de dois fatores (2FA) do 1Password",
  "Set up your customized reports, select the frequency your prefer, the properties to look at and share it with as many people as you want.": "Configure seus relatórios personalizados, selecione a frequência que você prefere, as propriedades para ver e compartilhá-lo com tantas pessoas quanto você quiser.",
  "Set your new password": "Set your new password",
  "Settings": "Settings",
  "Share": "Share",
  "Share property": "Share property",
  "Share site": "Compartilhe site",
  "Show all": "Mostrar todos",
  "Sign in": "Iniciar sessão",
  "Sign in here": "Iniciar sessão aqui",
  "Sign up to join": "Inicie sessão ou crie um novo perfil para se juntar a esta conta",
  "Single Apartment": "Apartamento individual",
  "Site information": "Informações sobre o sítio",
  "Site logo": "Logo do site",
  "Sites selected": "Sites selecionados",
  "Ski Resort": "Estância de esqui",
  "Something went wrong. Please try again or contact support via chat if the issue persists.": "Algo deu errado. Por favor, tente novamente ou contacte o suporte por chat se o problema persistir.",
  "Specific properties": "Specific properties",
  "Specific properties from this account.": "Specific properties from this account.",
  "Start grouping your properties however you like!": "Comece a agrupar suas propriedades como quiser!",
  "Start inviting users to your team.": "Start inviting users to your team.",
  "step by step guide here": "passo a passo guia aqui",
  "Take a tour": "Faça uma visita guiada",
  "Team": "Team",
  "The account does not exist": "A conta não existe",
  "The AI teammate that delivers intelligence, recommends your next move, and helps you act.": "O colega de equipe de IA que entrega inteligência, recomenda seu próximo movimento e ajuda você a agir.",
  "The chatbot cannot be initialised": "O chatbot não pode ser inicializado",
  "The field length must be between 1 and 60 characters long.": "O comprimento do campo deve estar compreendido entre 1 e 60 caracteres.",
  "The properties included will immediately become available to regroup in new brands.": "The properties included will immediately become available to regroup in new brands.",
  "The user already belongs to this account": "The user already belongs to this account",
  "The user has been locked out due to too many failed authentication attempts. Please {link} to continue.": "O usuário foi bloqueado devido a muitas tentativas de autenticação falhadas. Por favor, {link} para continuar.",
  "The user will no longer have access to the properties.": "The user will no longer have access to the properties.",
  "There was an error deleting the page": "Ocorreu um erro ao eliminar a página",
  "There was an error loading the page": "Ocorreu um erro ao carregar a página",
  "There was an error saving the page": "Ocorreu um erro ao guardar a página",
  "These pages are managed automatically": "Essas páginas são geridas automaticamente",
  "This action cannot be undone.": "Esta acção não pode ser desfeita.",
  "This field is required": "Este campo é obrigatório",
  "This field must be a valid email": "Este campo deve ser um e-mail válido",
  "This field must be a valid URL, e.g. https://hotel.com": "Este campo deve ser um URL válido, por exemplo, https://hotel.com",
  "This field must be at least {min} characters": "Este campo deve ter pelo menos {min} caracteres",
  "This image will be used for reports, notifications and other account communications.": "This image will be used for reports, notifications and other account communications.",
  "This is your THN tracking code for {propertyName}. This script allows us to track and follow the complete booking funnel throughout your website and analyze the right metrics of your direct booking performance, as well as display all the widgets and messages you configure.": "Este é o seu código de rastreamento THN para {propertyName}. Este script permite-nos acompanhar e monitorizar todo o funil de reservas no seu site e analisar as métricas relevantes do desempenho das suas reservas diretas, bem como apresentar todos os widgets e mensagens que configurar.",
  "This page is mapped to multiple properties, deleting it will delete the page for all of those properties.": "Esta página está mapeada para múltiplas propriedades, excluí-la excluirá a página para todas essas propriedades.",
  "This user already has access to all properties, you cant add more.": "This user already has access to all properties, you cant add more.",
  "This user will no longer be able to access to this/these property(ies).": "Este utilizador deixará de poder aceder a esta(s) propriedade(s).",
  "Timeshare": "Timeshare",
  "Timezone": "Timezone",
  "Title": "Title",
  "Transfer ownership": "Transferência de propriedade",
  "Transfer properties and delete brand": "Transferir propriedades e excluir marca",
  "Transfer properties and delete cluster": "Transferir propriedades e excluir cluster",
  "Transfer property": "Transferir propriedade",
  "Transfer this property to another brand": "Transferir esta propriedade para outra marca",
  "Transfer this property to another cluster": "Transferir esta propriedade para outro Cluster",
  "Transfer to another brand": "Transfer to another brand",
  "Transfer to another cluster": "Transfer to another cluster",
  "Untitled page": "Página sem título",
  "URL": "URL",
  "URL contains": "URL contém",
  "URL equals": "URL é igual a",
  "Use clusters to visualize and filter your properties categorizing them by similar variables: location, hotel type, number of stars and even by number of rooms.": "Use clusters to visualize and filter your properties categorizing them by similar variables: location, hotel type, number of stars and even by number of rooms.",
  "User": "User",
  "User invited": "User invited",
  "User removed": "Utilizador removido",
  "User role was successfully changed.": "A função do utilizador foi alterada com sucesso.",
  "User was successfully removed.": "User was successfully removed.",
  "Users": "Users",
  "Users invited": "Users invited",
  "Validating emails ...": "Validating emails ...",
  "Verify": "Verificar",
  "View brand": "Ver marca",
  "View cluster": "Ver cluster",
  "View info": "Ver informação",
  "View Property": "Ver propriedade",
  "View site": "Ver site",
  "Visualize and analyze your brand data classifying those properties within the same brand into one group.": "Visualize and analyze your brand data classifying those properties within the same brand into one group.",
  "We respect your privacy, therefore we will not share your personal information with third parties or partners.": "We respect your privacy, therefore we will not share your personal information with third parties or partners.",
  "Weekly": "Weekly",
  "Weekly:": "Weekly: ",
  "Welcome": "Bem-vindo",
  "Welcome {0},": "Bem-vindo {0},",
  "Welcome to THN": "Bem-vindo à THN",
  "Wellness & Spa": "Bem-estar e Spa",
  "Widget data": "Widget data",
  "Without it, messages won’t be shown and no data will be collected.": "Sem ele, as mensagens não serão mostradas e não serão recolhidos quaisquer dados.",
  "Write the number of rooms": "Write the number of rooms",
  "Yes, remove access": "Yes, remove access",
  "Yes, remove user": "Yes, remove user",
  "You are about to delete this brand": "Você está prestes a excluir esta marca",
  "You are about to delete this cluster": "Você está prestes a excluir este cluster",
  "You are about to transfer the ownership to this user. Your role will change to Operator, and you will no longer be able to edit the account information.": "Está prestes a transferir a propriedade para este utilizador. A sua função será alterada para Operador e deixará de poder editar as informações da conta.",
  "You can add it again later.": "You can add it again later.",
  "You can’t invite users that are already in the account": "Não é possível convidar utilizadores que já estejam na conta",
  "You haven't created any email notification yet": "Você ainda não criou nenhuma notificação de e-mail",
  "You will see brands here when an admin user creates them.": "Poderá ver aqui as marcas existentes quando um administrador as criar.",
  "You will see clusters here when an admin creates them.": "Poderá ver aqui os Clusters existentes quando um administrador os criar.",
  "Your brand was successfully removed.": "Your brand was successfully removed.",
  "Your Brand was successfully updated.": "Your Brand was successfully updated.",
  "Your cluster was successfully removed.": "Your cluster was successfully removed.",
  "Your Cluster was successfully updated.": "Your Cluster was successfully updated.",
  "Your new password has been successfully set": "Sua nova senha foi configurada com sucesso",
  "Your password was successfully changed.": "Sua senha foi alterada com sucesso.",
  "Your profile was successfully updated.": "O teu perfil foi atualizado com sucesso.",
  "Your Properties was successfully removed from brand.": "As suas propriedades foram removidas com sucesso da marca.",
  "Your Properties was successfully removed from cluster.": "Suas Propriedades foram removidas com sucesso do cluster.",
  "Your properties was successfully transferred.": "Os seus imóveis foram transferidos com sucesso.",
  "Your property was successfully updated.": "Your property was successfully updated.",
  "Your site was created.": "O seu site foi criado.",
  "Your site was successfully updated.": "Seu site foi atualizado com sucesso.",
  "Your verification session expired. Please sign in again.": "Sua sessão de verificação expirou. Por favor, entre novamente."
}